import React from 'react'
import PropTypes from 'prop-types'
import {Collapsible, CollapsibleTrigger, CollapsibleContent} from '@/components/ui/collapsible'
import CategoryLink from './categoryLink'

const NavItem = ({category, isOpen, onToggle}) => {
    const subCategories = category.categories
        ? category.categories.filter((item) => item.c_showInMenu)
        : []
    const lastSubCategoryIndex = subCategories ? subCategories.length - 1 : -1
    let addShowAllLink = true
    const hasParentLinkOnly = category.c_parentLinkOnly

    return subCategories.length > 0 && !hasParentLinkOnly ? (
        <Collapsible open={isOpen} onOpenChange={onToggle} data-testid="navItem-Collapsible">
            <CollapsibleTrigger
                className="w-full [&[data-state=closed]_svg]:-rotate-90"
                data-testid="navItem-CollapsibleTrigger"
            >
                <CategoryLink
                    categoryID={category.id}
                    categoryName={category.name}
                    altCategoryUrl={category.c_alternativeUrl}
                    hasSubCategories={true}
                    open={isOpen}
                    data-testid="navItem-CategoryLink"
                />
            </CollapsibleTrigger>
            <CollapsibleContent className="px-[0.9375rem]" data-testid="navItem-CollapsibleContent">
                {subCategories.map((subCategory, index) => {
                    if (
                        index === lastSubCategoryIndex &&
                        subCategory.name.toLowerCase() === 'shop all'
                    ) {
                        addShowAllLink = false
                        return (
                            <CategoryLink
                                key={subCategory.id}
                                categoryID={category.id}
                                categoryName="Shop All"
                                altCategoryUrl={category.c_alternativeUrl}
                                shopAll={true}
                                data-testid="navItem-CategoryLink"
                            />
                        )
                    } else {
                        return (
                            <NavItem
                                key={subCategory.id}
                                category={subCategory}
                                data-testid="navItem-NavItem"
                            />
                        )
                    }
                })}
                {addShowAllLink && (
                    <CategoryLink
                        categoryID={category.id}
                        categoryName="Shop All"
                        altCategoryUrl={category.c_alternativeUrl}
                        shopAll={true}
                        data-testid="navItem-CategoryLink"
                    />
                )}
            </CollapsibleContent>
        </Collapsible>
    ) : (
        <CategoryLink
            categoryID={category.id}
            categoryName={category.name}
            altCategoryUrl={category.c_alternativeUrl}
            data-testid="navItem-CategoryLink"
        />
    )
}

NavItem.propTypes = {
    category: PropTypes.object.isRequired,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func
}

export default NavItem
